import React from 'react';
import S from './styles';
import { TimetableItem } from "../timetable-item"

const timetableList = [
  {
    label: '13:00',
    title: '개회사',
    badge: ['Kuu'],
  },
  {
    label: '13:15',
    title: 'SSG의 뻔하지 않은 SwiftUI 도입 고민 (feat. WWDC22)',
    badge: ['dSunny'],
  },
    {
        label: '13:45',
        title: 'InjectionIII를 이용한 Hot Reload로 앱 개발하기',
        badge: ['민소네'],
    },
    {
        label: '14:15',
        title: '단톡방의 스마트 질문러',
        badge: ['제임스'],
    },
    {
        label: '14:45',
        title: '네트워킹 및 기념사진 촬영',
        badge: ['모두'],
    },
    {
        label: '16:00',
        title: '주니어 입장에서 바라보는 디자인패턴 & 아키텍쳐',
        badge: ['Ever'],
    },
  {
    label: '16:30',
    title: '만들면서 느껴보는 POP',
    badge: ['곰튀김'],
  },
    {
        label: '17:00',
        title: '이제 문서는 DocC로 만들때가 되지 않았나요?',
        badge: ['리이오'],
    },
  {
    label: '17:30',
    title: '폐회사 및 뒷풀이 안내',
    badge: ['Kuu'],
  },
];

export const Timetable = () => (
  <S.Section>
    <S.Title
      id='timetable'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      TIMETABLE
    </S.Title>
    <S.Wrap>
      {timetableList.map((item, index) => (<TimetableItem item={item} index={index} key={item.title} />))}
    </S.Wrap>
  </S.Section>
)
